'use strict'

module.exports.DEFAULT_PAGE_SIZE = 20
